import {defineMessages} from 'react-intl';

export default defineMessages({
  searchInput: {
    id: 'SellTicket.search.input',
    defaultMessage: 'Search'
  }
});
